import { render } from "./Tournament.vue?vue&type=template&id=a4d5170a&scoped=true"
import script from "./Tournament.vue?vue&type=script&lang=js"
export * from "./Tournament.vue?vue&type=script&lang=js"

import "./Tournament.vue?vue&type=style&index=0&id=a4d5170a&scoped=true&lang=css"
import "./Tournament.vue?vue&type=style&index=1&id=a4d5170a&lang=scss"
script.render = render
script.__scopeId = "data-v-a4d5170a"

export default script